export default __webpack_public_path__ + "static/media/ithiri1.5df9edea.png";